import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReadFilledSvg from "@ant-design/icons-svg/es/asn/ReadFilled";
import AntdIcon from '../components/AntdIcon';
var ReadFilled = function ReadFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ReadFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ReadFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ReadFilled';
}
export default RefIcon;